import { Box, Cell, Layout, Text } from '@wix/design-system';
import { Chat, ChatSmall } from '@wix/wix-ui-icons-common';
import _ from 'lodash';
import { FC } from 'react';
import { useProfileContext } from '../../Contexts/ProfileContext';

type Props = {
  isMobileView?: boolean;
};

const ProviderLanguages: FC<Props> = ({ isMobileView }) => {
  const {
    partnerProfile: { matchingPreferences },
    languages,
  } = useProfileContext();

  function getLanguages() {
    return _.map(matchingPreferences?.languages, (language) =>
      _.get(_.find(languages, { id: language }), 'value'),
    );
  }
  return (
    <Box
      direction="vertical"
      width="fit-content"
      style={{ display: 'flex', alignItems: 'baseline' }}
    >
      <Layout gap="3px" alignItems="end">
        <Cell span={1} vertical>
          <Box>
            <ChatSmall />
          </Box>
        </Cell>
        <Cell span={11} vertical>
          <Text size="small" weight="thin">
            {getLanguages().join(', ')}
          </Text>
        </Cell>
      </Layout>
    </Box>
  );
};

export default ProviderLanguages;
